import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconTimeNow({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 473 470"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#fff"
					d="M472.546 233.013c0 128.693-105.79 233.02-236.277 233.02S0 361.706 0 233.013 105.782 0 236.27 0s236.276 104.319 236.276 233.013"
				/>
				<path fill="#cd0400" d="M231 85h11v32h-11z" />
				<path
					stroke="#cd0400"
					strokeWidth={7}
					d="M321.934 121.58a4 4 0 0 1 5.636-.492l13.789 11.57a4 4 0 0 1 .493 5.635l-80.125 95.49A27 27 0 0 1 263 242c0 14.912-12.088 27-27 27s-27-12.088-27-27c0-3.18.55-6.23 1.559-9.063l-46.829-55.81a4 4 0 0 1 .493-5.635l13.79-11.57a4 4 0 0 1 5.634.493l46.362 55.252A27 27 0 0 1 236 215c2.356 0 4.64.302 6.819.868z"
				/>
				<g fill="#cd0400">
					<path d="M231 380h11v32h-11zM108.5 236.5v11h-32v-11zM414.5 230.5v11h-32v-11z" />
					<path d="M248.219 57.673c61.205 0 115.741 28.044 151.225 71.776-34.24-53.853-94.925-89.698-164.129-89.698-106.923 0-193.605 85.495-193.605 190.936 0 45.087 15.887 86.498 42.38 119.16-18.651-29.353-29.476-64.037-29.476-101.238 0-105.448 86.674-190.936 193.605-190.936" />
					<path
						fillRule="nonzero"
						d="M238.508 8.317v21.536h-6.456V8.317zM198.908 11.338l3.787 21.215-6.356 1.125-3.787-21.215zM160.44 21.096l7.472 20.235-6.06 2.219-7.47-20.235zM124.278 37.292l10.928 18.651-5.576 3.24-10.928-18.652zM91.522 59.434 105.56 75.93l-4.925 4.156-14.038-16.495zM63.16 86.86l16.73 13.845-4.126 4.944-16.73-13.846zM40.065 118.72l18.91 10.773-3.205 5.58L36.86 124.3zM22.926 154.057l20.517 7.362-2.188 6.048-20.517-7.361zM12.277 191.79l21.5 3.74-1.11 6.333-21.501-3.74zM30.262 230.778v6.429H8.43v-6.429zM33.013 266.087l1.11 6.333-21.5 3.74-1.111-6.333zM41.931 300.395l2.188 6.048-20.517 7.362-2.188-6.048zM56.754 332.652l3.205 5.58-18.903 10.765-3.205-5.58zM77.04 361.877l4.126 4.944-16.73 13.846-4.126-4.945zM102.149 387.196l4.926 4.155-14.03 16.495-4.926-4.155zM131.343 407.823l5.577 3.238L126 429.713l-5.577-3.238zM163.72 423.142l6.06 2.218-7.471 20.242-6.06-2.217zM198.292 432.688l6.356 1.125-3.787 21.216-6.356-1.126zM240.49 436.172v21.537h-6.455v-21.537zM276.204 432.355l3.787 21.207-6.356 1.126-3.787-21.208zM310.69 422.472l7.472 20.243-6.06 2.218-7.47-20.243zM342.922 406.843l10.92 18.652-5.578 3.238-10.92-18.652zM371.908 385.94l14.037 16.494-4.925 4.157-14.037-16.496zM396.78 360.376l16.73 13.846-4.127 4.944-16.73-13.845zM416.773 330.952l18.91 10.773-3.205 5.58-18.91-10.772zM431.288 298.558l20.517 7.362-2.188 6.048-20.517-7.362zM439.875 264.162l21.501 3.74-1.11 6.332-21.502-3.74zM464.112 228.822v6.429H442.28v-6.429zM459.92 189.865l1.11 6.333-21.5 3.74-1.111-6.333zM448.932 152.22l2.19 6.048-20.51 7.362-2.189-6.048zM431.486 117.029l3.206 5.58-18.903 10.772-3.206-5.58zM408.107 85.359l4.126 4.944-16.73 13.845-4.126-4.944zM379.497 58.18l4.926 4.154-14.03 16.495-4.926-4.154zM346.542 36.312l5.577 3.238-10.92 18.652-5.577-3.238zM310.234 20.427l6.06 2.217-7.463 20.235-6.06-2.217zM271.681 10.997l6.357 1.125-3.787 21.215-6.356-1.125z"
					/>
				</g>
				<g fillRule="nonzero">
					<path
						fill="#fff"
						d="M406.401 300.29h-65.596l-.243.005a7.5 7.5 0 0 0-7.257 7.496l-.001 77.044-24.455-11.279-.193-.085-.145-.06-.198-.078a7.5 7.5 0 0 0-8.377 11.822l67.895 81.834.145.168.11.122.153.163a7.5 7.5 0 0 0 11.136-.453l67.895-81.834.138-.174.1-.13.132-.18a7.5 7.5 0 0 0-1.353-10.077l-.176-.14-.13-.1a6 6 0 0 0-.182-.132l-.236-.159a7.5 7.5 0 0 0-7.207-.507l-24.455 11.28v-77.045a7.5 7.5 0 0 0-7.5-7.5"
					/>
					<path
						fill="#cd0400"
						d="M402.913 297.5h-65.597l-.243.004a7.5 7.5 0 0 0-7.257 7.496v77.045l-24.455-11.28-.194-.085-.144-.06-.198-.077a7.5 7.5 0 0 0-8.377 11.822l67.895 81.833.145.168.11.122.152.163a7.5 7.5 0 0 0 11.137-.453l67.895-81.833.238-.305.131-.18a7.5 7.5 0 0 0-1.353-10.076l-.175-.14-.13-.1a6 6 0 0 0-.183-.133l-.236-.159a7.5 7.5 0 0 0-7.206-.507l-24.456 11.28.001-77.045a7.5 7.5 0 0 0-7.5-7.5"
					/>
				</g>
			</g>
		</svg>
	);
}
